import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	newObjectLabel: {
		id: 'servicedesk-insight-editable-referenced-object-picker.new-object-label',
		defaultMessage: 'New Object',
		description: 'Label for select option to create a new referenced object',
	},
	errorFlagTitle: {
		id: 'servicedesk-insight-editable-referenced-object-picker.error-flag-title',
		defaultMessage: "We couldn't complete the search for your objects",
		description: 'Error title when failing to search for an CMDB referenced object attribute',
	},
	errorFlagDescription: {
		id: 'servicedesk-insight-editable-referenced-object-picker.error-flag-description',
		defaultMessage: 'Please refresh and try again',
		description:
			'Generic error description when failing update an CMDB referenced object attribute',
	},
});
